import React from 'react';

import { GameType } from '../game/game';
import { GameUiModule } from '../game/game-module';
import { get } from '../util/fetch';
import { GameEvent } from './events/event';
import { updateCatan } from './catan.reducer';
import { CatanView, normaliseCatanView } from './catan-view';
import { installCatanDebug } from './catan-debug';

const CatanRoot = React.lazy(() => import('./Catan'));

// Development-only: exposes window.catanDebug so a tester can drive a game from
// the console. A no-op in production builds.
installCatanDebug();

/** How the client hosts Catan. */
export const catanUiModule: GameUiModule<CatanView> = {
  gameType: GameType.Catan,
  title: 'Catan',
  splash: `${process.env.PUBLIC_URL}/catan/splash.png`,
  loadView: (gameId: string) =>
    get<CatanView>(`/game/${gameId}/state`).then(normaliseCatanView),
  reduce: (view, event) => updateCatan(view, event as GameEvent),
  Root: CatanRoot,
};
